<template>
  <div class="ma-4 app">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row>
        <v-col v-for="n in 4" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-for="p in 10" :key="`spacer_${p}`" />
        <v-col>
          <v-skeleton-loader type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col>
          <CalendarWithMultipleAndRange
            label="Dias"
            v-model="dateSelected"
            :date-props="dateProps"
            :text-field-props="textProps"
          />

        </v-col>

        <v-col>
          <ClockRange
            label="Horas"
            min_max="true"
            v-model="timeSelected"
            :time-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
          />
        </v-col>
        <v-col v-if="!selectByDepartament">
          <v-autocomplete
            v-model="form.operadores"
            :items="operadores"
            outlined
            multiple
            dense
            :label="'Operadores'"
            :error-messages="operadoresErrors"
            @input="$v.form.operadores.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption">
                  (+{{ form.operadores.length - 1 }})
                </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.operadores.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item ripple @click="toggleOperadoresAtivos">
                <v-list-item-action>
                  <v-icon
                    :color="somenteOperadoresAtivos ? 'indigo darken-4' : ''"
                  >
                    {{ iconOperadoresAtivos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Operadores Ativos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col v-if="selectByDepartament">
          <v-autocomplete
          dense
          outlined
          multiple
          v-model="departamentosSelecionados"
          :items="departamentos"
          label="Departamento"
          :error-messages="departamentoErrors"
          @input="$v.departamentosSelecionados.$touch()">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ departamentosSelecionados.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleDepartamento">
                <v-list-item-action>
                  <v-icon :color="departamentosSelecionados.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconDepartamento }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            multiple
            dense
            outlined
            label="Centro de Custo"
            v-model="form.centrosDeCusto"
            :items="centrosDeCusto"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption">
                  (+{{ form.centrosDeCusto.length - 1 }})
                </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleCentroDeCustos">
                <v-list-item-action>
                  <v-icon
                    :color="
                      form.centrosDeCusto.length > 0 ? 'indigo darken-4' : ''
                    "
                  >
                    {{ iconCentroDeCusto }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-text-field
              :value="maiorQue"
              @change="v => (maiorQue = v)"
              dense
              outlined
              label="Duração maior que"
              hint="hh:mm:ss"
              v-mask="['##:##:##', '##:##','##']"
              persistent-hint
              @input="$v.maiorQue.$touch()"
              :error-messages="maiorQueErrors"
            />
        </v-col>
      </v-row>

      <v-row dense>
        <v-spacer />
        <v-col cols="4" class="mt-n9 mr-6">
          <v-radio-group dense v-model="selectByDepartament" row>
            <v-radio
              label="Departamento"
              color="bluePcm"
              :value="true"
              @change="radioDepartamentoSelecionados"
            />
            <v-radio
              label="Operador"
              color="bluePcm"
              :value="false"
              @change="radioOperadorSelecionado"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="3" class="text-right">
          <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel">Exportar Excel</v-btn>
          <v-btn dark color="bluePcm" @click="gerar">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />

    <div v-show="showRelatorio">
      <v-sheet class="px-3 pt-3 pb-3" v-show="showSkeleton">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>

      <div v-show="!showSkeleton">
        <div v-show="responseOperadores.length === 0">
          <p class="text-h5">
            Não foram encontrados dados com estes filtros.
          </p>
        </div>
        <div v-show="responseOperadores.length > 0">
          <ExpansionList
            :panel="panel"
            :operadores="responseOperadores"
            :openExpansionList="permissaoAbrirHistorico"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import relatorioDiretoOperadorHttpService from '../_services/relatorioDiretoOperadorHttpService'

import { registerVuexModule } from "@/utils/vuexUtils";
import { initialAndFinalDateTextInputReportForm } from "@/mixins/initialAndFinalDateTextInputReportForm";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import { relatoriosOperadorMixins } from "../../../_mixins/relatoriosOperadorMixins";

import ExpansionList from "../../components/ExpansionList";

import relatorioDiretoOperadorResumidoStore from '../_store'

import CalendarWithMultipleAndRange from "@/componentes/CalendarWithMultipleAndRange";
import ClockRange from "@/componentes/ClockRange";
import moment from "moment";

export default {
  name: "RelatorioOperadorDiretoResumido",
  components: { ExpansionList, CalendarWithMultipleAndRange, ClockRange },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosOperadorMixins],
  data: () => ({
    panel: [],
    permissaoAbrirHistorico: true,
    arrayPermissoesAbrirHistorico: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_TOTAL,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_GRAVACAO_HISTORICO,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_OUVIR_GRAVACAO,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_HISTORICO,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_VISUALIZAR_CONDICIONADO,
    ],
    responseOperadores: [],
    form: {
      operadores: [],
      centrosDeCusto: [],
      maiorQue: 0,
    },
    showRelatorio: false,
    dateSelected:{},
    timeSelected:{},
  }),

  computed: {
    ...mapGetters('relatorioDiretoOperadorResumido', ['getDadosRelatorio']),
    dateTimeRange(){
      return {...this.dateSelected,...this.timeSelected}
    },
  },

  async created() {
    registerVuexModule(
      this.$store,
      "relatorioDiretoOperadorResumido",
      relatorioDiretoOperadorResumidoStore
    );

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    arrayPermissions.forEach((permissionFromLocalStorage) => {
      if (
              this.arrayPermissoesAbrirHistorico.includes(permissionFromLocalStorage)
      ) {
        this.permissaoAbrirHistorico = false;
      }
    });
    this.timeSelected = {timeStart: '00:00', timeEnd: '23:59'}
    this.dateSelected = {dateIsRange: true, dates:[moment().format("YYYY-MM-DD")]}

  },

  methods: {
    ...mapActions("relatorioDiretoOperadorResumido", [
      "gerarRelatorioDiretoOperadorResumido",
    ]),
    ...obtainUserPermissions,

    // Comportamento dos radio buttons

    radioDepartamentoSelecionados() {
      this.departamentosSelecionados = [];
      this.showRelatorio = false;
    },
    radioOperadorSelecionado() {
      this.form.operadores = [];
      this.showRelatorio = false;
    },

    // ===

    async gerar() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }

      // Caso outro relatorio tenha sido gerado, fecha itens que estiverem abertos antes de gerar outro
      this.panel.splice(0);
      // =====
      this.showRelatorio = true;
      this.showSkeleton = true;

      this.form.dateTimeRange = this.dateTimeRange;

      await this.gerarRelatorioDiretoOperadorResumido(this.form);
      this.responseOperadores = [...this.getDadosRelatorio];
      this.showSkeleton = false;
    },

    async exportExcel() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }
      const params = {
        dateTimeRange: this.dateTimeRange,
        operadores: this.form.operadores,
        centrosDeCusto: this.form.centrosDeCusto,
        maiorQue: this.form.maiorQue,
      }
      window.open(relatorioDiretoOperadorHttpService.exportExcel(params));
    },

  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
